import styled from 'styled-components';
import friends from '~/assets/icons/friends.svg';
import plusRound from '~/assets/icons/plus_round.svg';
import minusRound from '~/assets/icons/minus_round.svg';
import { TextLabel } from '../TextLabel';

const StyledContainer = styled.div`
	position: relative;
`;

const StyledRequestsButton = styled.div`
	position: relative;
	width: 26px;
	height: 26px;
	cursor: pointer;

	.dot {
		position: absolute;
		top: 0;
		right: 0;
		width: 6px;
		height: 6px;
		border-radius: 6px;
		background: #ff3e3e;
		box-shadow: 0 0 6px rgba(255, 62, 62, 0.75);
	}

	.icon {
		position: absolute;
		left: 0;
		bottom: 0;
		width: 20px;
		height: 20px;
		background-image: url(${friends});
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
	}
`;

const StyledListContainer = styled.div`
	position: absolute;
	top: 36px;
	right: 0;
	z-index: 10;
	display: flex;
	flex-direction: column;
	gap: 17px;
	width: 280px;
	padding: 17px 20px 20px;
	background: rgba(255, 255, 255, 0.9);
	border-radius: 10px;
	opacity: 0;
	transition: opacity 0.3s ease;

	&.list-enter {
		opacity: 0;
	}

	&.list-enter-active,
	&.list-enter-done,
	&.list-exit {
		opacity: 1;
	}

	&.list-exit-active {
		opacity: 0;
	}
`;

const StyledList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;

	.line {
		width: 100%;
		height: 1px;
		background-color: rgba(0, 0, 0, 0.1);
	}
`;

const StyledListItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledItemLeftContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledImg = styled.img`
	width: 40px;
	height: 40px;
	border-radius: 40px;
	object-fit: cover;
`;

const StyledItemPlayerInfo = styled.div`
	${TextLabel} {
		&:nth-child(1) {
			font-weight: 500;
			font-size: 12px;
			color: #000000;
		}

		&:nth-child(2) {
			font-weight: 400;
			font-size: 10px;
			color: #000000;
			opacity: 0.5;
		}
	}
`;

const StyledButtonsContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledButton = styled.div`
	width: 20px;
	height: 20px;
	opacity: 0.25;
	filter: invert(100%);
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
	transition: opacity 0.3s ease;
	cursor: pointer;

	&:hover {
		opacity: 1;
	}
`;

const StyledAcceptButton = styled(StyledButton)`
	background-image: url(${plusRound});
`;

const StyledRejectButton = styled(StyledButton)`
	background-image: url(${minusRound});
`;

export {
	StyledRequestsButton,
	StyledContainer,
	StyledListContainer,
	StyledList,
	StyledListItem,
	StyledItemLeftContainer,
	StyledImg,
	StyledItemPlayerInfo,
	StyledButtonsContainer,
	StyledAcceptButton,
	StyledRejectButton,
};
